import { withPromotionItemProps } from 'viewModel/content/promotionList/promotionItem/withPromotionItemProps';
import PromotionItem from 'components/Content/PromotionList/PromotionItem/PromotionItem';

export default withPromotionItemProps(PromotionItem);
